import { createContext, useContext, useEffect, useState } from "react";

const FavoritesContext = createContext(null);
const KEY = "yegros_favorites";

export const FavoritesProvider = ({ children }) => {
  const [codes, setCodes] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(codes)); }, [codes]);

  const isFav = (code) => codes.includes(code);
  const toggle = (code) => setCodes((prev) => (prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code]));

  return <FavoritesContext.Provider value={{ codes, isFav, toggle, count: codes.length }}>{children}</FavoritesContext.Provider>;
};

export const useFavorites = () => useContext(FavoritesContext);
